import { observable } from "mobx"
import { BookingFlow } from "../BookingFlow"

export class Modal {
  constructor(flow: BookingFlow, onSave?: () => void, onCancel?: () => void) {
    if (!flow) throw new Error("Missing param flow")
    this.flow = flow
    this.localOnCancel = onCancel
    this.localOnSave = onSave
  }

  flow: BookingFlow

  localOnCancel?: () => void
  localOnSave?: () => void

  onSave() {
    this.flow.shouldShowModal = false
    this.localOnSave && this.localOnSave()
  }

  onCancel() {
    this.flow.shouldShowModal = false
    this.localOnCancel && this.localOnCancel()
  }

  @observable
  title = ""

  @observable
  children: JSX.Element

  @observable
  doneButtonClicked = new Date()

  @observable
  cancelButtonClicked = new Date()

  @observable
  primaryButtonText = ""

  @observable
  primaryDisabled = true

  @observable
  errorMessage?: string
}
